<style scoped lang="scss">
    .muted {
        color: #999;
    }
</style>

<template>
    <div class="step-wrapper" v-if="application && confirmation">
        <div class="uk-grid">
            <div class="uk-align-center uk-width-small-1-1 uk-width-medium-4-5">

                <div class="uk-grid renter-info">
                    <div class="uk-width-1-1 uk-margin-large-bottom">
                        <h1>Do You Approve?</h1>
                        <p>Your participation in this program will help ensure {{ applicant.first_name }} does not become a further victim of COVID 19. This aid must reinstate them to avoid eviction. Your commitment by accepting this aid means any current eviction process will be cancelled, and no new eviction process can start from 30 days of receipt of the funds.</p>
                    </div>
                    <hr class="uk-width-1-1">
                    <div class="uk-width-1-1 uk-flex uk-flex-space-between">
                        <div>
                            <h2>{{ applicant.first_name }} {{ applicant.last_name }}</h2>
                        </div>

                        <div>
                            <h2>{{ applicant.primary_contact.formatted_number }}</h2>
                        </div>
                    </div>

                    <div class="uk-width-1-2 uk-text-left">
                        <h3>
                            {{ applicant.property_address.line_1 }}
                            {{ applicant.property_address.line_2 }}
                        </h3>
                    </div>
                    <div class="uk-width-1-2 uk-text-right">
                        <h3>
                            {{ applicant.property_address.city }}
                        </h3>
                    </div>

                    <div class="uk-width-1-1 uk-margin-bottom">
                        <hr>
                    </div>
                </div>

                <div class="uk-grid total-requested">

                    <div class="uk-width-1-1 uk-margin-bottom">
                        <div class="uk-align-left">
                            <h2>Total Requested Aid:</h2>
                        </div>
                        <div class="uk-align-right">
                            <h2>{{ getTotalRentRequested | formatMoney }}</h2>
                        </div>
                    </div>
                </div>


                <div class="uk-grid selection-buttons">
                    <div class="uk-width-small-1-1 uk-margin-large-bottom uk-width-medium-1-3 uk-text-left-medium">
                        <input type="radio"  v-model="confirmation.approval" value="approved">
                        <label style="font-size: 1.2em;">I Approve {{ getTotalRentRequested | formatMoney }}</label>


                    </div>
                    <div class="uk-width-small-1-1 uk-margin-large-bottom uk-width-medium-1-3 uk-text-left-small">
                        <validated-section field="corrected" :errors="errors">
                            <input type="radio"  v-model="confirmation.approval" value="corrected">
                            <label style="font-size: 1.2em;">This Amount Needs Correction</label>
                        </validated-section>
                    </div>

                    <div class="uk-width-small-1-1 uk-margin-large-bottom uk-width-medium-1-3 uk-text-right-medium">
                        <input type="radio"  v-model="confirmation.approval" value="declined">
                        <label style="font-size: 1.2em;">I Do Not Wish To Participate</label>
                    </div>
                </div>

                <div v-if="isEditMode" class="uk-grid total-requested" >

                    <div class="uk-width-1-1 uk-margin-bottom">
                        <div class="uk-align-left">
                            <h2>Total Updated Aid:</h2>
                        </div>
                        <div class="uk-align-right">
                            <h2>{{ updatedAmount | formatMoney }}</h2>
                        </div>
                    </div>
                </div>
                <div v-if="confirmation.approval !== 'declined' " class="uk-grid request-details uk-margin-large-bottom">
                    <div class="uk-overflow-container uk-hidden-small uk-width-medium-1-1">
                        <table class="uk-width-1-1 uk-table uk-table-divider uk-table-striped">
                            <thead>
                            <tr>
                                <th class="">Month</th>
                                <th class="">Rent Due</th>
                                <th class="">Rent Paid</th>
                                <th class="" v-if="application.program.settings['uses-ledger-entry-fees']">Fees Due</th>
                                <th class="" v-if="application.program.settings['uses-duplicative-assistance']">Other Assistance Amount</th>
                                <th class="uk-text-right">Total Requested</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(values, month) in confirmation.edited_amount_meta" v-if="isEditMode || getRentMetaForDate(month)">
                                <td>
                                    {{ values.date | moment('MMM YYYY') }}
                                </td>
                                <td>
                                    <div v-if="isEditMode">
                                        <vue-numeric :precision="2" currency="$" v-model="confirmation.edited_amount_meta[month].due"></vue-numeric>
                                    </div>
                                    <div :class="{muted: isEditMode}">
                                        <span v-if="isEditMode">Tenant Entered:</span>
                                        {{ getRentMetaForDate(month).due | formatMoney }}
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <div v-if="isEditMode">
                                            <vue-numeric :precision="2" currency="$" v-model="confirmation.edited_amount_meta[month].paid"></vue-numeric>
                                        </div>
                                        <div :class="{muted: isEditMode}">
                                            <span v-if="isEditMode">Tenant Entered:</span>
                                            {{ getRentMetaForDate(month).paid | formatMoney }}
                                        </div>
                                    </div>
                                </td>
                                <td v-if="application.program.settings['uses-ledger-entry-fees']">
                                    <div>
                                        <div v-if="isEditMode">
                                            <vue-numeric :precision="2" currency="$" v-model="confirmation.edited_amount_meta[month].fees" @change.native="checkMaxFees(month)"></vue-numeric>
                                        </div>
                                        <div :class="{muted: isEditMode}">
                                            <span v-if="isEditMode">Tenant Entered:</span>
                                            {{ getRentMetaForDate(month).fees | formatMoney }}
                                        </div>
                                    </div>
                                </td>
                                <td v-if="application.program.settings['uses-duplicative-assistance']">
                                    <div class="uk-margin-bottom"
                                        v-for="(program, i) in values.alternative_funding_programs"
                                        :key="i"
                                    >
                                        <div v-if="isEditMode">
                                            <currency-input :currency="{ prefix: '$ '}" v-model="program.pivot.amount"/>
                                            <select placeholder="Select Source"
                                                    v-model="program.pivot.alternative_funding_program_id"
                                                    class="uk-input uk-select" style="width: 175px;">
                                                <option :value="null">Choose a Source...</option>
                                                <option 
                                                    v-for="(_program, i1) in alternativeFundingPrograms"
                                                    :key="i1"
                                                    :value="_program.id"
                                                >
                                                    {{ _program.name }}
                                                </option>
                                            </select>
                                            <a href="javascript:;" class="uk-text-danger"
                                            v-if="isEditMode"
                                            @click="values.alternative_funding_programs.splice(i, 1)"><i
                                                    class="a-trash-2"></i></a>
                                        </div>
                                        <div :class="{muted: isEditMode}">
                                            <div v-if="getUniteLedgerDataForDate(month).alternative_funding_programs.hasOwnProperty(i)">
                                                <span v-if="isEditMode">Tenant Entered:</span>
                                                <span>{{ getUniteLedgerDataForDate(month).alternative_funding_programs[i].pivot.amount | formatMoney }} - {{ getAlernativeFundProgramName(getUniteLedgerDataForDate(month).alternative_funding_programs[i].pivot.alternative_funding_program_id) }} </span>
                                            </div>
                                        </div>
                                    </div>
                                    <a href="javascript:;"
                                    v-if="isEditMode"
                                    @click="addAssistance(values.alternative_funding_programs)"><i
                                            class="a-circle-plus"></i> Report Other Funding Received</a>
                                </td>
                                <td class="uk-text-right">
                                    <div v-if="isEditMode">
                                        {{ getTotalRequestByMonth(month) | formatMoney }}
                                    </div>
                                    <div :class="{muted: isEditMode}">
                                        <span v-if="isEditMode">Tenant Entered:</span>
                                        {{ getTotalRequestByMonth(month, 'tenant') | formatMoney }}
                                    </div>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked">
                        <div class="uk-width-1-1 uk-grid" v-for="(values, month) in confirmation.edited_amount_meta">
                            <div class="uk-width-1-1">
                                <h4>
                                    {{ values.date | moment('MMM YYYY') }}
                                </h4>

                            </div>
                            <div class="uk-width-1-1 uk-margin-top uk-margin-large-bottom">
                                <div class="uk-form-row">
                                    <label class="uk-form-label" for="">{{ values.date | moment('MMM YYYY') }} Due</label>
                                    <div v-if="isEditMode">
                                        <vue-numeric :precision="2" currency="$" v-model="confirmation.edited_amount_meta[month].due"></vue-numeric>
                                    </div>
                                    <div :class="{muted: isEditMode}">
                                        <span v-if="isEditMode">Tenant Entered:</span>
                                        {{ getRentMetaForDate(month).due | formatMoney }}
                                    </div>
                                </div>
                                <div class="uk-form-row">
                                    <label class="uk-form-label" for="">{{ values.date | moment('MMM YYYY') }} Rent Paid</label>
                                    <div v-if="isEditMode">
                                        <vue-numeric :precision="2" currency="$" v-model="confirmation.edited_amount_meta[month].paid"></vue-numeric>
                                    </div>
                                    <div :class="{muted: isEditMode}">
                                        <span v-if="isEditMode">Tenant Entered:</span>
                                        {{ getRentMetaForDate(month).paid | formatMoney }}
                                    </div>
                                </div>
                                <div class="uk-form-row" v-if="application.program.settings['uses-ledger-entry-fees']">
                                    <label class="uk-form-label" for="">{{ values.date | moment('MMM YYYY') }} Fees Due</label>
                                    <div v-if="isEditMode">
                                        <vue-numeric :precision="2" currency="$" v-model="confirmation.edited_amount_meta[month].fees"></vue-numeric>
                                    </div>
                                    <div :class="{muted: isEditMode}">
                                        <span v-if="isEditMode">Tenant Entered:</span>
                                        {{ getRentMetaForDate(month).fees | formatMoney }}
                                    </div>
                                </div>
                                <div class="uk-form-row">
                                    <label class="uk-form-label" for="">{{ values.date | moment('MMM YYYY') }} Amount Requested</label>
                                    <div v-if="isEditMode">
                                        {{ getRentMetaForDate(month).due + getRentMetaForDate(month).fees - getRentMetaForDate(month).paid - getRentMetaForDate(month).other_funding | formatMoney }}
                                    </div>
                                    <div :class="{muted: isEditMode}">
                                        <span v-if="isEditMode">Tenant Entered:</span>
                                        {{ getRentMetaForDate(month).due + getRentMetaForDate(month).fees - getRentMetaForDate(month).paid - getRentMetaForDate(month).other_funding | formatMoney }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { mapState } from 'vuex';
    import moment from "moment";
    import ValidatedSection from "../../../components/Common/ValidatedSection";

    export default {
        name: "Step1",
        components: {ValidatedSection},
        data() {
            return {
                errors: {},
                checkedMonths: [],
                months: [
                    // moment('2020-04-15'),
                    // moment('2020-05-15'),
                    // moment('2020-06-15'),
                    // moment('2020-07-15'),
                    // moment('2020-08-15'),
                    // moment('2020-09-15'),
                    // moment('2020-10-15'),
                    // moment('2020-11-15'),
                    // moment('2020-12-15'),
                ],
            }
        },
        computed: {
            isEditMode() {
                return this.confirmation.approval === 'corrected';
            },

            getTotalRentRequested() {
                let total = 0;
                _.each(this.application.requested_rent_meta, row => {
                    const alternativeFundingProgramRecord = JSON.parse(JSON.stringify(this.getUniteLedgerDataForDate(row.date)));
                    const alternativeFundingProgram = alternativeFundingProgramRecord.alternative_funding_programs ? alternativeFundingProgramRecord.alternative_funding_programs: []
                    let totalAdditionalFund = alternativeFundingProgram.reduce((sum, item) => sum + parseFloat(item.pivot.amount), 0)
                    total += parseFloat(row.due) + parseFloat(row.fees) - parseFloat(row.paid) - totalAdditionalFund;
                })
                return total;
            },

            updatedAmount() {
                let total = 0;
                _.each(this.confirmation.edited_amount_meta, value => {
                    let alternativeFundingProgram = value.alternative_funding_programs ? value.alternative_funding_programs : []
                    let totalAdditionalFund = alternativeFundingProgram.reduce((sum, item) => sum + parseFloat(item.pivot.amount), 0)
                    let toAdd = value.fees + value.due - value.paid - totalAdditionalFund;
                    total += toAdd;
                })
                return total;
            },
            ...mapState('Application', {
                application: state => state.application,
                applicant: state => state.applicant,
                alternativeFundingPrograms: state => state.assets.alternativeFundingPrograms,
            }),
            ...mapState('Landlord', {
                confirmation: state => state.confirmation,
            }),
        },
        watch: {
            application(newValue) {
                if(newValue) {
                    this.createEditValues();
                }
            },
            confirmation(newValue, oldValue) {
                if(!oldValue) {
                    this.createEditValues();
                }

                if(this.confirmation.approval === null) {
                    this.confirmation.approval = 'approved';
                }

                if(!newValue.edited_amount_meta || !newValue.edited_amount_meta.length) {
                    this.createEditValues();
                }
            },
            approval(newValue) {
                this.$store.commit('Landlord/setApproval', newValue);
            },
        },
        mounted() {
            if(this.confirmation) {
                if(!this.confirmation.edited_amount_meta.length) {
                    this.createEditValues();
                }
                // this.createEditValues();
            }

            if(this.confirmation && this.confirmation.approval === null) {
                this.confirmation.approval = 'approved';
            }
        },
        methods: {
            getTotalRequestByMonth(month, type = 'landlord')
            {
                let result = 0
                let totalAdditionalFund = 0;
                let alternativeFundingProgram = []
                if (type == 'landlord')
                {
                    alternativeFundingProgram = this.confirmation.edited_amount_meta[month].alternative_funding_programs ? this.confirmation.edited_amount_meta[month].alternative_funding_programs : []
                } else {
                    const alternativeFundingProgramRecord = JSON.parse(JSON.stringify(this.getUniteLedgerDataForDate(month)));
                    alternativeFundingProgram = alternativeFundingProgramRecord.alternative_funding_programs ? alternativeFundingProgramRecord.alternative_funding_programs : [];
                }

                if (alternativeFundingProgram.length) {

                    totalAdditionalFund = alternativeFundingProgram.reduce((sum, item) => sum + parseFloat(item.pivot.amount), 0)
                }
                if (type == 'landlord')
                {
                    result = this.confirmation.edited_amount_meta[month].due + this.confirmation.edited_amount_meta[month].fees -this. confirmation.edited_amount_meta[month].paid
                } else {
                    result = this.getRentMetaForDate(month).due + this.getRentMetaForDate(month).fees - this.getRentMetaForDate(month).paid
                }
                return result - totalAdditionalFund
            },
            getAlernativeFundProgramName(id) {
                const p = this.alternativeFundingPrograms.find(item => item.id == id);
                return p ? p.name : 'N/A';
            },
          addAssistance(programs) {
            programs.push({
                isNew: true,
                pivot: {
                    alternative_funding_program_id: null,
                    amount: 0,
                }
            })
          },
          checkMaxFees(month) {
            let maxFees = null;
            _.each(this.application.program.unit_ledger_entry_types, type => {
              if(type.id == 1 && type.pivot && type.pivot.max_fee_amount) {
                maxFees = type.pivot.max_fee_amount;
              }
            })

            if(maxFees != null && this.confirmation.edited_amount_meta[month].fees > maxFees) {
              UIkit.modal.alert('The maximum fee amount for this assistance type is $' + maxFees + '. We have adjusted your fee amount accordingly. ' );
              this.confirmation.edited_amount_meta[month].fees = maxFees;
            }
          },
            getRentMetaForDate(date) {
                for(var i in this.application.requested_rent_meta) {
                    let row = this.application.requested_rent_meta[i];
                    if(row.date == date) {
                        return {
                            date,
                            due: parseFloat(row.due),
                            paid: parseFloat(row.paid),
                            fees: parseFloat(row.fees),
                            other_funding: this.getOtherFundingTotal(row),
                        };
                    }
                }
                return {
                    due: 0, fees: 0, paid: 0,
                };
            },
            getOtherFundingTotal(row) {
                let total = 0;
                _.each(row.alternative_funding_programs, program => {
                    total += parseFloat(program.pivot.amount);
                })
                return total;
            },
            getUniteLedgerDataForDate(date) {
                const row =  this.application.unit_ledger_entries.find(item => item.date == date)
                return row ? row : {
                    alternative_funding_programs: [],
                    pivot: {}
                }
            },
            updateAlternativeFundingPrograms() {
                _.each(this.months, month => {
                    let monthString = month.format('YYYY-MM');
                    const alternativeFundingProgramRecord = JSON.parse(JSON.stringify(this.getUniteLedgerDataForDate(monthString)));
                    const alternativeFundingProgram = alternativeFundingProgramRecord.alternative_funding_programs ? alternativeFundingProgramRecord.alternative_funding_programs : [];
                    const LLAlternativeFundingProgram = this.confirmation.edited_amount_meta[monthString].alternative_funding_programs ? this.confirmation.edited_amount_meta[monthString].alternative_funding_programs : []

                    if (alternativeFundingProgram.length > LLAlternativeFundingProgram.length)
                    {
                        for (var i = LLAlternativeFundingProgram.length; i < alternativeFundingProgram.length; i++)
                        {
                            LLAlternativeFundingProgram.push(alternativeFundingProgram[i]);
                        }
                    }
                    if (alternativeFundingProgram.length < LLAlternativeFundingProgram.length)
                    {
                        for (var i = alternativeFundingProgram.length; i < LLAlternativeFundingProgram.length; i++)
                        {
                            if (!LLAlternativeFundingProgram[i].isNew)
                            {
                                LLAlternativeFundingProgram.splice(i, 1)
                            }
                        }
                    }
                    this.$set(this.confirmation.edited_amount_meta[monthString] , 'alternative_funding_programs', LLAlternativeFundingProgram);
                });
            },
            createEditValues() {
                let start = moment(this.application.program.assistance_start);
                let end = moment(this.application.program.assistance_end);
                let added = parseInt(this.application.program.settings['ledger-entry-future-months']) + 1;
                _.each(this.application.program.unit_ledger_entry_types, entryType => {
                    if(entryType.id === 1 && entryType.pivot.additional_months) {
                        added = parseInt(entryType.pivot.additional_months);
                    }
                });
                let endToShow = moment().clone().add(added, 'months');
                let months = [];
                while(start.isBefore(end)) {

                    if(start.isAfter(endToShow)) break;
                    if(start.isAfter(end)) break;

                    months.push(start.clone());

                    start.add(1, 'month');
                }

                this.months = months;
                if(this.confirmation) {
                    if (!_.size(this.confirmation.edited_amount_meta))
                    {
                        this.$set(this.confirmation , 'edited_amount_meta', {});
                        _.each(this.months, month => {
                            let monthString = month.format('YYYY-MM');
                            let record = this.getRentMetaForDate(monthString)
                            let alternativeFundingProgramRecord = JSON.parse(JSON.stringify(this.getUniteLedgerDataForDate(monthString)))
                            if(record) {
                                this.checkedMonths.push(month.month());
                            }
                            this.$set(this.confirmation.edited_amount_meta, monthString, {
                                date: month,
                                due: record ? parseFloat(record.due) : 0,
                                paid: record ? parseFloat(record.paid) : 0,
                                fees: record ? parseFloat(record.fees) : 0,
                                alternative_funding_programs: alternativeFundingProgramRecord && alternativeFundingProgramRecord.alternative_funding_programs ? alternativeFundingProgramRecord.alternative_funding_programs : [],
                            });
                        });
                    } else {
                        this.updateAlternativeFundingPrograms()
                    }
                }
            },
            async validateStep() {
                this.errors = {}
                if(this.approval === 'corrected') {
                    if(this.application.requested_rent_amount === this.updatedAmount) {
                        this.errors['corrected'] = { errors: ['You indicated the amount needs correction, but you made no changes.']}
                    }
                }


                if(_.size(this.errors) !== 0) {
                    return false;
                }

                let url = `/api/landlord/${this.confirmation.id}/step-1`;
                try {
                    let r = await axios.post(url, {
                        approval: this.confirmation.approval,
                        values: this.confirmation.edited_amount_meta,
                        updated_amount: this.updatedAmount,
                    });
                    console.log(r);
                    this.$store.commit('Landlord/setConfirmation', r.data.confirmation);
                    return true;
                }catch(err) {
                    this.errors = err.response.errors;
                    console.error(err);
                    return false;
                }
            }
        }
    }
</script>
